const ERR_COLOR = '#E36049'

/**
 * A hibaablak tartalmát generáló factory függvény.
 * @param message - Az ablak üzenet része.
 * @param stack   - A normalizált stacktrace, tömbbe rendezve.
 */
export default function makeContent (message: string, stack: string[]): HTMLElement {
  const content = document.createElement('div')

  const stackRows = stack.map((row, index) => {
    const [ func ] = row.split('@')

    const text = index === 0
      ? `<span style="color: ${ ERR_COLOR }"><-- OTT a hiba!</div>`
      : ''

    return `<tr><td>${ func }</td><td>${ text }</td></tr>`
  }).join('')

  const stackTable = `
    <table>
      <tbody>
        ${ stackRows }
      </tbody>
    </table>
  `

  content.innerHTML = `
    <div style="padding: 10px;">
      <h2 style="font-weight: 700; color: ${ ERR_COLOR }; margin: 0; padding: 0;">
        ${ message }
      </h2>
      <div style="font-size:14px; color: ${ ERR_COLOR }">(console-ban pontosabb stacktrace van!)</div>
      ${ stackTable }
    </div>
  `

  return content
}
